import React from "react";
import { BaseFolder } from "react-keyed-file-browser";
import FolderIcon from "@material-ui/icons/Folder";
import FolderOpenIcon from "@material-ui/icons/FolderOpen";
import RemoveIcon from "@material-ui/icons/Remove";
import {
  Grid,
  IconButton,
  TextField,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import ActionMenu from "./actionMenu";
import { timeFormat } from "../../utils/format";
import { styles } from "./styles";

class TableFolder extends BaseFolder {
  constructor(props) {
    super(props);
    this.state = {
      isRenaming: false,
      newName: "",
    };
    this.onChange = this.onChange.bind(this);
    this.getNameColumn = this.getNameColumn.bind(this);
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  getNameColumn() {
    const { isDraft, name } = this.props;
    const { newName } = this.state;
    if (isDraft) {
      return (
        <TextField
          value={newName}
          name="newName"
          autoFocus
          onChange={this.handleNewNameChange}
          onBlur={this.handleCancelEdit}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              this.handleRenameSubmit(event);
            }
          }}
        />
      );
    } else {
      return (
        <a
          href="#e"
          onClick={(e) => {
            e.preventDefault();
          }}
          color="primary"
        >
          {name}
        </a>
      );
    }
  }
  render() {
    const {
      code,
      key,
      url,
      download,
      thumbnail,
      size,
      createdAt,
      name,
      relativeKey,
      depth,
      isOpen,
      browserProps,
      children,
    } = this.props;
    const { deleteFile, selection } = browserProps;
    return (
      <TableRow>
        <TableCell
          style={{
            paddingLeft: depth + 1 + "rem",
            borderLeft: selection.includes(relativeKey)
              ? "4px solid rgb(25, 118, 210)"
              : "none",
          }}
          onClick={(event) => {
            this.handleFolderClick(event);
            this.handleFolderDoubleClick(event);
          }}
        >
          <Grid container alignItems="flex-end" wrap="nowrap">
            {isOpen ? (
              <FolderOpenIcon
                style={{
                  marginRight: "0.5rem",
                }}
              />
            ) : (
              <FolderIcon
                style={{
                  marginRight: "0.5rem",
                }}
              />
            )}
            {this.getNameColumn()}
          </Grid>
        </TableCell>

        <TableCell>
          <IconButton disabled color="secondary">
            <RemoveIcon />
          </IconButton>
        </TableCell>
        <TableCell>
          {timeFormat({ time: createdAt, format: "HH:mm:ss, DD/MM/YYYY" })}
        </TableCell>
        <TableCell>
          {children.length === 0 ? (
            <ActionMenu
              remove={() => {
                deleteFile({
                  code,
                  key,
                  url,
                  download,
                  thumbnail,
                  size,
                  createdAt,
                  name,
                  relativeKey,
                });
              }}
              allowRename={false}
              allowView={false}
              allowRemove={true}
            />
          ) : (
            <div>
              <IconButton disabled color="secondary">
                <RemoveIcon />
              </IconButton>
            </div>
          )}
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(styles)(TableFolder);
